import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  totalFlows: "Total Flows",
  flowsSubtitle: (p: { draft: string; active: string; completed: string }) =>
    `${p.draft} draft, ${p.active} active, ${p.completed} completed`,
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    totalFlows: "Nombre total de parcours",
    flowsSubtitle: (p) => `${p.draft} brouillons, ${p.active} actifs, ${p.completed} terminés`,
  },
  es_ES: {
    totalFlows: "Total de flujos",
    flowsSubtitle: (p) => `${p.draft} borradores, ${p.active} activos, ${p.completed} completados`,
  },
  pt_BR: {
    totalFlows: "Total de fluxos",
    flowsSubtitle: (p) => `${p.draft} rascunhos, ${p.active} ativos, ${p.completed} concluídos`,
  },
  de_DE: {
    totalFlows: "Flows gesamt",
    flowsSubtitle: (p) => `${p.draft} Entwürfe, ${p.active} aktiv, ${p.completed} abgeschlossen`,
  },
  it_IT: {
    totalFlows: "Totale flussi",
    flowsSubtitle: (p) => `${p.draft} bozze, ${p.active} attivi, ${p.completed} completati`,
  },
  ar: {
    totalFlows: "إجمالي المسارات",
    flowsSubtitle: (p) => `${p.draft} مسودة، ${p.active} نشط، ${p.completed} مكتمل`,
  },
  ja_JP: {
    totalFlows: "フロー合計",
    flowsSubtitle: (p) => `下書き ${p.draft}、進行中 ${p.active}、完了 ${p.completed}`,
  },
  hi_IN: {
    totalFlows: "कुल फ़्लो",
    flowsSubtitle: (p) => `${p.draft} ड्राफ़्ट, ${p.active} सक्रिय, ${p.completed} पूर्ण`,
  },
  zh_CN: {
    totalFlows: "流程总数",
    flowsSubtitle: (p) => `${p.draft} 个草稿，${p.active} 个进行中，${p.completed} 个已完成`,
  },
  zh_TW: {
    totalFlows: "流程總數",
    flowsSubtitle: (p) => `${p.draft} 個草稿，${p.active} 個進行中，${p.completed} 個已完成`,
  },
  nl_NL: {
    totalFlows: "Totaal aantal flows",
    flowsSubtitle: (p) => `${p.draft} concept, ${p.active} actief, ${p.completed} voltooid`,
  },
  nb_NO: {
    totalFlows: "Totalt antall flyter",
    flowsSubtitle: (p) => `${p.draft} utkast, ${p.active} aktive, ${p.completed} fullført`,
  },
  sv_SE: {
    totalFlows: "Totalt antal flöden",
    flowsSubtitle: (p) => `${p.draft} utkast, ${p.active} aktiva, ${p.completed} slutförda`,
  },
  fi_FI: {
    totalFlows: "Prosesseja yhteensä",
    flowsSubtitle: (p) => `${p.draft} luonnos, ${p.active} aktiivinen, ${p.completed} valmis`,
  },
  da_DK: {
    totalFlows: "Forløb i alt",
    flowsSubtitle: (p) => `${p.draft} kladde, ${p.active} aktive, ${p.completed} gennemført`,
  },
  is_IS: {
    totalFlows: "Ferli alls",
    flowsSubtitle: (p) => `${p.draft} drög, ${p.active} virk, ${p.completed} lokið`,
  },
};
